import { BaseContext } from '../../../utils/basecontext';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../uicomponent';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { UIComponentView } from '../uicomponentview';
import { HeaderCSSStyleImpl } from './headercss';
import { HeaderViewImpl } from './headerview';
import { LanguageConst } from '../../../utils/resources/languageconst';

export interface HeaderComponentProps extends UIComponentProps 
{
    onLanguageChange(languageSelected: LanguageConst): void;
    onFaqClicked(): void;
    onAboutClicked():void;
}

export class HeaderComponent extends UIComponentImpl<HeaderComponentProps, UIComponentState, UIDataModel>
{
    constructor(props: HeaderComponentProps) {
        super(props);
    }
    
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel> {
        return new HeaderViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle {
        return new HeaderCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/header/headercomponent.tsx